import { useGet } from '../../HttpClient';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { AccountFlagDefinitionModel } from '../../../models/referenceDataModels';

export function useAccountAvailableFlags() {
  const get = useGet(true, "ams");
  const getAccountAvailableFlags = (): Promise<AccountFlagDefinitionModel[]> =>
      get(`/api/proxy/ams/account-service/available-flag-definitions`);
  return useQueryWithErrorHandling({
    queryKey: ['get-account-available-flags'],
    enabled: true,
    queryFn: async () => await getAccountAvailableFlags(),
  });
}
